import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

// 👇 Yahan se hero image change kar sakte ho (right side wali badi image)
const HERO_IMAGE = '/login-side.webp';

const LoginPage = () => {
  const [email,    setEmail]    = useState('admin@bhamsa.com');
  const [password, setPassword] = useState('admin123');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      sessionStorage.setItem('bhamsa_just_logged_in', 'true');
      toast.success('Login ho gaya! 🎉');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">

        {/* Left: form panel */}
        <div className="login-panel">
          <div className="login-panel-inner">
            <div className="login-brand">
              <img src="/bhamsalogo.png" alt="Bhamsa" className="login-brand-logo" />
            </div>

            <div className="login-heading">
              <h1>Welcome back</h1>
              <p>Login to manage your inventory &amp; billing</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  className="form-input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="admin@bhamsa.com"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Password</label>
                <div className="password-wrap">
                  <input
                    className="form-input"
                    type={showPass ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPass(s => !s)}
                    aria-label={showPass ? 'Hide password' : 'Show password'}
                  >
                    {showPass ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary login-submit"
                disabled={loading}
              >
                {loading ? (
                  <><span className="spinner-sm" /> Login ho raha hai...</>
                ) : (
                  '🔐 Login'
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Right: hero image panel */}
        <div
          className="login-hero"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        >
          <div className="login-hero-overlay" />
        </div>

      </div>
    </div>
  );
};

export default LoginPage;